import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";

const CLIENTS = [
  { name: "CtrlS Datacenters", logo: "/client-ctrls.png" },
  { name: "Grundfos", logo: "/client-grundfos.png" },
  { name: "Dürr", logo: "/client-durr.png" },
  { name: "Vishakha Glass", logo: "/client-vishakha.png" },
];

const fadeUp = {
  hidden: { opacity: 0, y: 40 },
  visible: { opacity: 1, y: 0, transition: { duration: 0.7, ease: [0.16, 1, 0.3, 1] } },
};

const Clientele = () => (
  <section id="clientele" className="relative bg-slate-50 border-t border-slate-200 py-28 sm:py-32 overflow-hidden">
    <div className="max-w-[1600px] mx-auto px-6 sm:px-10">
      <motion.div
        initial="hidden"
        whileInView="visible"
        viewport={{ once: true, margin: "-100px" }}
        variants={fadeUp}
        className="mb-16 max-w-2xl"
      >
        <p className="font-mono text-xs uppercase tracking-[0.3em] text-[#1C8FC4] mb-6">04 / Clientele</p>
        <h2 className="font-heading font-bold uppercase text-[#1A2E4A] text-4xl sm:text-5xl tracking-tight">
          Trusted across sectors.
        </h2>
      </motion.div>
    </div>

    <div data-testid="clientele-marquee" className="border-y border-slate-200 py-10 bg-white">
      <Marquee speed={28} gradient={false} pauseOnHover>
        {[...CLIENTS, ...CLIENTS].map((client, i) => (
          <div
            key={i}
            data-testid={`clientele-logo-${client.name.replace(/\s+/g, "-").toLowerCase()}-${i}`}
            className="mx-12 h-14 sm:h-16 flex items-center"
          >
            <img
              src={client.logo}
              alt={client.name}
              className="h-full w-auto max-w-[180px] object-contain transition-transform duration-300 hover:scale-110"
            />
          </div>
        ))}
      </Marquee>
    </div>

    <div className="max-w-[1600px] mx-auto px-6 sm:px-10 mt-10">
      <p className="font-mono text-xs uppercase tracking-[0.2em] text-slate-500">
        Data Centers &middot; Pumps &amp; Fluid Systems &middot; Automotive Engineering &middot; Glass Manufacturing
      </p>
      <p
        data-testid="clientele-disclaimer"
        className="mt-8 font-body text-[11px] text-slate-400 leading-relaxed max-w-3xl"
      >
        Disclaimer: The names, trademarks&trade;, and logos used on this website are the property of their
        respective owners. The use of these names does not imply any affiliation with or endorsement by the
        respective companies, nor do we claim any rights or ownership over them. All trademarks and
        registered trademarks mentioned are solely for informational purposes.
      </p>
    </div>
  </section>
);

export default Clientele;

